import { HashTable } from "@/utils/HashTable";
import { VeicleLastGps } from "./vehicleLastGps";
import { getIconByDirection } from "@/utils/VehicleHelper";
import { EventBus } from "@/utils/event-bus.js";

function VeicleLastGpsList() {
    this.map;
    this.vehicleList = new HashTable();

    this.init = (map) => {
        this.map = map;
    }

    this.updateGps = (info) => {
        if (info && info.VehicleID) {
            var k = this.vehicleList.items(info.VehicleID);
            if (k) {
                k.updateGps(info);
                // 如果vehicleList里面只有一台车，更新地图中心点到车辆当前位置
                // console.log(this.vehicleList.count()+"一台车");
                //Lat

                if (this.vehicleList.count() === 1 && info.Lon && info.Lat) {
                    this.map.setCenter(info.Lon, info.Lat);
                }
            }
        }
    }

    // 批量更新车辆GPS信息
    this.batchUpdateGps = (gpsList) => {


        this.map.clearMarkerCluster();
        if (!gpsList || !Array.isArray(gpsList) || gpsList.length === 0) {
            return;
        }

        const markersData = [];

        gpsList.forEach(gpsInfo => {

            if (!gpsInfo || !gpsInfo.VehicleID || !gpsInfo.Lon || !gpsInfo.Lat) {
                return;
            }

            // 获取车辆信息
            const vehicleItem = this.vehicleList.items(gpsInfo.VehicleID);
            if (!vehicleItem) {
                return;
            }

            const vehicleInfo = vehicleItem.vehicleInfo;

            // 更新GPS信息
            vehicleItem.gpsInfo = Object.assign({}, gpsInfo);

            // 构建标记数据
            markersData.push({
                id: "v_" + gpsInfo.VehicleID,
                name: vehicleInfo.vehicleName + "(" + gpsInfo.Speed + " km/h)",
                lng: gpsInfo.Lon,
                lat: gpsInfo.Lat,
                iconUrl: getIconByDirection(gpsInfo.Direction),
                callback: () => {
                    EventBus.$emit("showOnMapEvent", {
                        gpsInfo: vehicleItem.gpsInfo,
                        vehicleInfo: vehicleInfo,
                    });
                }
            });
        });
     
        // 如果有数据，先清除旧标记，再批量添加新标记
        if (markersData.length > 0) {

            this.map.addMarkersToCluster(markersData);
        }

        // 如果只有一辆车，更新地图中心点
        if (this.vehicleList.count() === 1 && gpsList.length > 0) {
            const firstGps = gpsList[0];
            if (firstGps.Lon && firstGps.Lat) {
                this.map.setCenter(firstGps.Lon, firstGps.Lat);
            }
        }
    }

    // 更新车辆列表（添加/移除车辆）
    this.updateVehicles = (vehicles) => {
        // 遍历新的车辆列表，更新或添加
        vehicles.forEach(v => {
            if (v.treeLevel == 5) {
                if (this.vehicleList.contains(v.nodeValue)) {
                    var k = this.vehicleList.items(v.nodeValue);
                    k.updateDestroyFlag(0);
                } else {
                    var t = new VeicleLastGps();
                    t.init(this.map, v);
                    this.vehicleList.add(v.nodeValue, t);
                }
            }
        });

        // 循环车辆列表，判断标志位，如果没有不销毁的，进行销毁
        this.vehicleList.keys(v => {
            var k = this.vehicleList.items(v);
            if (k.destroyFlag == 1) {
                k.destroy();
                this.vehicleList.remove(v);
            } else {
                k.updateDestroyFlag(1);
            }
        });
    }
    // 清除所有车辆的GPS信息
    this.clearAll = () => {
         this.map.clearMarkerCluster();
        this.vehicleList.clear();
    }



    // 获取所有车辆ID
    this.getVehicleIds = () => {
        const ids = [];
        this.vehicleList.keys(v => {
            ids.push(v);
        });
        return ids;
    }

    // 获取车辆数量
    this.count = () => {
        return this.vehicleList.count();
    }

}

export { VeicleLastGpsList };